import { render } from "./HHPreadmissionNotes.vue?vue&type=template&id=a522ef44"
import script from "./HHPreadmissionNotes.ts?vue&type=script&lang=js&external"
export * from "./HHPreadmissionNotes.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__